import { MouseEventHandler, useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import Banner, {
  bannerProps,
} from "@Components/contentful-components/banner/Banner";
import Icon from "@Components/ui/icon/Icon";
import classes from "@Styles/components/_hero-image.module.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const HERO_Slider = "hero-slider";

interface heroSliderProps {
  banners: {
    items: bannerProps[];
  };
  customBanner?: () => React.ReactNode;
  onSlideChange?: (currentSlide: number) => void;
}
interface IArrowProps {
  className?: string;
  currentSlide?: number;
  "data-role"?: string;
  slideCount?: number;
  style?: {};
  onClick?: MouseEventHandler;
}
interface IRefProps extends Slider {
  slickGoTo: (currentSlide: number) => {};
}
const HeroSlider = ({
  banners,
  customBanner,
  onSlideChange,
}: heroSliderProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef<IRefProps>(null);

  const goToSlide = (slide: number) => {
    if (sliderRef.current) sliderRef.current.slickGoTo(slide);
  };

  useEffect(() => {
    onSlideChange?.(currentSlide);
  }, [currentSlide, onSlideChange]);

  const SamplePrevArrow = (props: IArrowProps) => {
    const { currentSlide } = props;
    const arrowClass = `${classes["arrow"] + " " + classes["arrow-left"]}`;

    const handleLeftArrowClick = () => {
      if (currentSlide !== undefined && currentSlide === 0) goToSlide(-1);
      else if (currentSlide && currentSlide > 0) goToSlide(currentSlide - 1);
    };

    return (
      <div className={arrowClass} onClick={handleLeftArrowClick}>
        <Icon iconName="arrow-left-thin" />
      </div>
    );
  };

  const SampleNextArrow = (props: IArrowProps) => {
    const { slideCount, currentSlide } = props;
    const arrowClass = `${classes["arrow"]} ${classes["arrow-right"]}`;

    const handleRightArrowClick = () => {
      if (slideCount && currentSlide !== undefined && currentSlide < slideCount)
        goToSlide(currentSlide + 1);
    };

    return (
      <div className={arrowClass} onClick={handleRightArrowClick}>
        <Icon iconName="arrow-right-thin" />
      </div>
    );
  };

  const sliderSettings = {
    beforeChange: (_prev: number, next: number) => {
      setCurrentSlide(next);
    },
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    dotsClass: `${classes["slick-dots"]}`,
    speed: 250,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    cssEase: "linear",
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
  };

  if (banners?.items?.length === 0) return null;

  return (
    <>
      <div
        className={`${classes["section"]} ${classes["section--slider"]} ${classes["section--slideshow"]} ${classes["js-scroll-reveal"]} ${classes["section__home-page-hero"]} ${classes["section--transition"]}`}
      >
        <div className={classes["section__content"]}>
          <div className={`${classes["tns-outer"]} ${classes["tns1-ow"]}`}>
            <div className={`${classes["tns-mw"]} ${classes["tns-ovh"]}`}>
              <div className={`${classes["tns-inner"]} ${classes["tns1-iw"]}`}>
                <div
                  className={`${classes["slider"]} ${classes["tns-slider"]} ${classes["tns-carousel"]} ${classes["tns-subpixel"]} ${classes["tns-calc"]} ${classes["tns-horizontal"]} ${classes["tns1"]}`}
                >
                  <Slider {...sliderSettings} ref={sliderRef}>
                    {banners?.items?.map((item, i) =>
                      customBanner ? (
                        <div key={item.name + i}>{customBanner()}</div>
                      ) : (
                        <Banner {...item} key={`${item.name}-${i}`} />
                      )
                    )}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSlider;
